module.exports = __webpack_public_path__ + "img/0.3edde8d3.png";